/**
 * 　(c) 2020 TERAOKA SEIKO CO., LTD. / 株式会社 寺岡精工
 * 　CONFIDENTIAL / 社外秘
 * 　無断開示・無断複製禁止
 */
<script>
    export default {
        created: function(){
            this.$nextTick(function(){
                // TABインデックスを制御
                this.toggleTabIndex(true);
                // モーダル要素を取得
                var target = $('.modal-container');
                var count = target.length;
                if (count > 0) {
                    // モーダルのうち一番上のモーダルだけ解除
                    var i = count-1;
                    var selectore = target[i].id ? '#'+target[i].id : '.modal-container';
                    this.toggleTabIndex(false, selectore);
                }
            }.bind(this));
        },
        destroyed: function(){
            // モーダル要素を取得
            var target = $('.modal-container');
            var count = target.length;
            if (count == 0) {
                // モーダルが無い場合、全てのTABインデックスを解除
                this.$nextTick(function(){
                    this.toggleTabIndex(false, this.m_parent);
                }.bind(this));
            } else {
                // 残っているモーダルのうち一番上のモーダルだけ解除
                var i = count-1;
                var selectore = target[i].id ? '#'+target[i].id : '.modal-container';
                this.$nextTick(function(){
                    this.toggleTabIndex(false, selectore);
                }.bind(this));
            }
        },
		data: function(){
			return {
                // 制御対象となる要素の要素(デフォルト)
                m_parent: '.body, .header',
                
                // 制御対象となる要素をCSSセレクターで指定
				m_elements: [
                    'button',
                    'input',
                    'textarea',
                    'select',
                    'a',
                    'label[role="radio"]',
                    'div[role="tab"]',
                    ],

                // 常にtabIndex=-1としたい要素をCSSセレクターで指定
                m_ignore: [
                    '.el-radio__original',          // ラジオボタン
                    '.el-radio-button__orig-radio', // ラジオボタン(トグル)
                    '.breadcrumb a',                // パンくずリスト
                ],

                // 制御は行うが解除時にtabIndex属性を消す要素をCSSセレクターで指定
                m_normal: [
                    'div[data-toggle="collapse"]',  // アコーディオン
                    'input[type="checkbox"]',       //
                    '.el-checkbox',                 // チェックボックス
                    '.el-checkbox__original',       // チェックボックス
                    'a',                            // リンク
                ],
                // 制御は行うが解除時にtabIndex=0とする要素をCSSセレクターで指定
                m_focus: [
                    '.tr-td-control a',             // 一覧行内リンク
                    '.el-radio-group label.el-radio', // ラジオボタングループ
                ],
			}
        },
        methods: {
            /**
             * 対象セレクター取得
             * 親要素(parent),対象要素(elements)を指定しない場合
             * デフォルトの値(this.m_parent,this.m_elements)が使用されます
             */
            getSelector: function(parent, elements){
                var result = [];
                // 親要素
                var parentElement = (parent) ? parent : this.m_parent;
                var targetElements = (elements) ? elements : this.m_elements;
                // 親要素と対象要素を組み合わせてセレクターを作る
                var parentClasses = parentElement.split(',');
                for (let p = 0; p < parentClasses.length; p++) {
                    const parentTarget = $.trim(parentClasses[p]);
                    var map = $.map( targetElements, function( element, i ) {
                        return ( parentTarget + ' ' + element );
                    });
                    result = result.concat(map);
                }
                return result.join(',');
            },
            /**
             * 指定要素のTABインデックス切り替え
             * flag: true => tabIndex=-1, false => tabIndex=0
             */
            toggleTabIndex:function(flag, parent){
                // 対象を取得
                var elements = document.querySelectorAll(this.getSelector(parent));
                // 全ての対象に対してtabIndexを設定
                elements.forEach(element => {
                    element.tabIndex = flag ? -1 : 0;
                });
                // tabIndex=-1固定要素を設定し直す
                var ignores = document.querySelectorAll(this.getSelector(parent, this.m_ignore));
                ignores.forEach(element => {
                    element.tabIndex = -1;
                });

                if (!flag) {
                    // 解除時にtabIndex属性を消す
                    var normals = document.querySelectorAll(this.getSelector(parent, this.m_normal));
                    normals.forEach(element => {
                        element.removeAttribute('tabIndex');
                    });
                    // 解除時にtabIndex=0にする
                    var focus = document.querySelectorAll(this.getSelector(parent, this.m_focus));
                    focus.forEach(element => {
                        element.tabIndex = (this.checkClassName(element.tagName, element.classList)) ? -1 : 0;
                    });
                }
            },
            /**
             * 指定要素のクラスチェック
             * true: tabindexに -1 を設定
             * false: tabindexに 0 を設定
             */
            checkClassName: function(tagName, classList) {
                var result = false;
                
                if (!tagName || !classList) return result;

                // el-radio
                if (tagName == 'LABEL' && classList.contains('el-radio')) {
                    // true:未選択or選択不可、false:選択)
                    result = (!classList.contains('is-checked')) ? true : false;
                // その他
                } else {
                    result = false;
                }

                return result;
            },
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/common/tabIndex.mixin.vue